import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const SOCIALS = [
  { handle: "@thewild3rs", platform: "Instagram", url: "https://www.instagram.com/thewild3rs" },
  { handle: "@thewild3rsq4d", platform: "Instagram", url: "https://www.instagram.com/thewild3rsq4d" },
  { handle: "@wildbe10", platform: "Instagram", url: "https://www.instagram.com/wildbe10" },
  { handle: "@bedliw", platform: "Instagram", url: "https://www.instagram.com/bedliw" },
];

export const WILDER_AVATAR = "/images/wilder-avatar.png";

export const PLATFORMS = [
  { name: "Gronda", url: "https://thewilders.gronda.com", desc: "Le ricette professionali complete dello Chef" },
  { name: "Patreon", url: "https://www.patreon.com/user?u=191538076&utm_campaign=creatorshare_creator", desc: "Contenuti esclusivi e dietro le quinte della CREW" },
];

export const LOGO_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_wildersquad-hub/artifacts/1on64v8a_WilderSquad_Logo_Esemplare_SfondoPieno_1500px.png";
